// extracted by mini-css-extract-plugin
export default {"cameraView":"RecordVideo_cameraView__bv1Po","recordButton":"RecordVideo_recordButton__bSaAK"};